import { useState } from 'react'
import * as styles from './Dropdown.module.scss'
import classNames from 'classnames'

const keyEvents = {
  ArrowDown: (currentOptionIndex, totalOptions) => {
    if (totalOptions === currentOptionIndex) {
      return 1
    }

    return currentOptionIndex + 1
  },
  ArrowUp: (currentOptionIndex, totalOptions) => {
    if (currentOptionIndex <= 1) {
      return totalOptions
    }

    return currentOptionIndex - 1
  },

  End: (_, totalOptions) => {
    return totalOptions
  },

  Home: () => {
    return 1
  }
}

const DropdownOption = ({
  activeOption,
  currentOptionIndex,
  handleOptionSelect,
  id,
  text
}) => {
  const isActive = currentOptionIndex + 1 === activeOption
  const classes = classNames(
    styles.dropdownListOption,
    isActive ? styles.dropdownListOptionActive : undefined
  )

  return (
    <li
      id={id}
      role="option"
      onMouseDown={() => handleOptionSelect(currentOptionIndex + 1)}
      className={classes}
      aria-selected={isActive ? 'true' : undefined}>
      {text}
    </li>
  )
}

const Dropdown = ({ options, onSelect, placeholder, id }) => {
  const [showList, setShowList] = useState(false)
  const [activeOption, setActiveOption] = useState(0)
  const [selectedOption, setSelectedOption] = useState()

  const handleOnClick = () => {
    if (activeOption !== 0) {
      setSelectedOption(activeOption)
      setActiveOption(0)
      onSelect(options[activeOption - 1])
    }

    setShowList(!showList)
  }

  const handleKeyboardEvent = (event) => {
    const newActiveIndex = keyEvents[event.key]
      ? keyEvents[event.key](activeOption, options.length)
      : undefined

    if (newActiveIndex && showList) {
      setActiveOption(newActiveIndex)
    }
  }

  const handleOnBlur = () => {
    setActiveOption(0)
    setShowList(false)
  }

  const handleOptionSelect = (newActiveIndex) => {
    setSelectedOption(newActiveIndex)
    setActiveOption(0)
    onSelect(options[newActiveIndex - 1])
    setShowList(false)
  }

  const optionsId = activeOption ? options[activeOption - 1].id : undefined

  const listBoxClasses = classNames(
    styles.dropdownListContent,
    showList ? styles.dropdownListContentShow : undefined
  )

  return (
    <div className={styles.dropdown}>
      <button
        className={styles.dropdownButton}
        aria-haspopup="true"
        aria-expanded={showList ? 'true' : 'false'}
        aria-labelledby={`${id}${optionsId ? ` ${optionsId}` : ''}`}
        id={id}
        type="button"
        onClick={handleOnClick}
        onBlur={handleOnBlur}
        onKeyDown={(e) => e.preventDefault()}
        onKeyUp={handleKeyboardEvent}>
        {placeholder}
        <span aria-hidden={showList ? 'true' : 'false'}>
          {options[selectedOption - 1]
            ? ` ${options[selectedOption - 1].text}`
            : ''}
        </span>
      </button>
      <ul
        role="listbox"
        aria-labelledby={id}
        className={listBoxClasses}
        tabIndex="-1"
        aria-activedescendant={optionsId}>
        {options.map((option, index) => (
          <DropdownOption
            key={option.id}
            {...option}
            currentOptionIndex={index}
            activeOption={activeOption}
            handleOptionSelect={handleOptionSelect}
          />
        ))}
      </ul>
    </div>
  )
}

export default Dropdown
